import { useEffect, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Trending from "@/pages/home/components/Trending";
import Categories from "@/pages/home/components/Categories";
import Feed from "@/pages/home/components/Feed";
import Poll from "@/pages/home/components/Poll";
import About from "@/pages/home/components/About";
import Faq from "@/pages/home/components/Faq";
import Submit from "@/pages/home/components/Submit";
import Footer from "@/pages/home/components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <Categories />
        <Feed />
        <Poll />
        <About />
        <Faq />
        <Submit />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}